import {
    requestPublic,
    request
} from './request.js'

// 获取报修记录列表
export function getMaintainRecordList() {
    return request({
        url: '/api2/StudentAccommodationApi/StudentTheRepair/GetList',
        method: 'get',
    })
}

//获取报修记录详情
export function getMaintainDetails(id) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentTheRepair/GetDetail',
        method: 'get',
        params:{
			id:id
		}
    })
}

//报修评价
export function postMaintainRecord(params){
	return request({
		url:'/api2/StudentAccommodationApi/StudentTheRepair/TheRepairEvaluation',
		method:'post',
		data:params
	})
}